import { Link } from 'react-router-dom';
import { Seo } from '../components/Seo';
import { Reveal } from '../components/Reveal';
import { ArrowIcon } from '../components/ArrowIcon';
import { BrandLogo } from '../components/BrandLogo';
import { BRAND, SERVICES } from '../lib/brand';

const CONTENT_TEASERS = [
  { tag: '기초', title: '타로 카드, 어디서부터 시작할까', description: '메이저 아르카나 22장의 큰 흐름을 따라가며 타로의 기본 구조를 소개합니다.' },
  { tag: '상징', title: '별과 태양, 그리고 달의 상징', description: '카드 속 천체 상징이 리딩에서 어떻게 읽히는지 정리했습니다.' },
  { tag: '스토리', title: '타로상담바라는 공간에 대하여', description: '2017년, 국내 최초 타로상담바가 문을 열기까지의 이야기.' }
];

export function HomePage() {
  return (
    <div className="tm-page">
      <Seo
        title="타로맨스 | 강남 타로상담바"
        description="타로와 칵테일, 대화가 만나는 문화 바. 타로 상담, 시그니처 칵테일, 커뮤니티, 클래스까지 — 강남 타로맨스."
      />

      {/* Hero */}
      <section className="tm-hero">
        <div className="tm-hero-bg">
          <img src="/assets/taromance/stitch-final/hero-bar.jpg" alt="타로맨스 바 내부, 은은한 조명과 바 테이블" />
        </div>
        <div className="tm-hero-inner">
          <p className="tm-eyebrow">Since {BRAND.since} · 국내 최초 타로상담바 · 강남</p>
          <div className="tm-hero-wordmark" aria-hidden="true">
            <BrandLogo />
          </div>
          <h1 className="tm-display">
            타로와 칵테일,
            <br />
            대화가 만나는 <em>문화 바</em>
          </h1>
          <div className="tm-hero-actions">
            <Link className="tm-btn tm-btn--solid" to="/reserve">예약하기</Link>
            <a className="tm-btn tm-btn--ghost" href="#services">서비스 둘러보기</a>
          </div>
          <div className="tm-hero-meta">
            <span>영업시간<strong>{BRAND.hours.label} {BRAND.hours.time}</strong></span>
            <span>위치<strong>강남 · 도곡로11길 10 1층</strong></span>
            <span>타로 상담<strong>무료</strong></span>
          </div>
        </div>
      </section>

      {/* Service hub */}
      <section className="tm-section" id="services">
        <div className="tm-container">
          <Reveal>
            <div className="tm-hub-head">
              <div>
                <p className="tm-eyebrow">What We Do</p>
                <h2 className="tm-h2">
                  하룻밤의 경험부터
                  <br />
                  깊이 있는 배움까지
                </h2>
              </div>
              <p className="tm-body-text" style={{ maxWidth: '26em' }}>
                타로맨스는 술을 파는 곳이 아니라 경험이 머무는 곳입니다. 다섯 가지 방식으로 타로를 만나보세요.
              </p>
            </div>
          </Reveal>
          <div className="tm-hub-grid">
            {SERVICES.map((service, index) => (
              <Reveal key={service.slug} className="tm-service-card" delay={index * 60}>
                <div className="tm-service-card-media">
                  <img src={service.image} alt={service.title} loading="lazy" />
                </div>
                <div className="tm-service-card-body">
                  <div className="tm-service-card-index">
                    <span>{String(index + 1).padStart(2, '0')}</span>
                    <span>{service.labelEn}</span>
                  </div>
                  <h3 className="tm-h3">{service.title}</h3>
                  <p className="tm-body-text">{service.description}</p>
                  <Link className="tm-arrow-link" to={service.slug}>
                    {service.cta}
                    <ArrowIcon />
                  </Link>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* Ops snapshot */}
      <section className="tm-section tm-section--tight tm-section--line tm-section--deep">
        <div className="tm-container">
          <div className="tm-ops">
            <Reveal className="tm-ops-item">
              <h3>Hours</h3>
              <strong>{BRAND.hours.label} {BRAND.hours.time}</strong>
              <span>매출 피크는 20시–22시. 여유 있는 대화를 원하신다면 이른 저녁을 추천합니다.</span>
            </Reveal>
            <Reveal className="tm-ops-item" delay={80}>
              <h3>Location</h3>
              <strong>{BRAND.address}</strong>
              <span>
                <Link to="/visit" style={{ color: 'var(--tm-gold)' }}>오시는 길과 편의 정보 보기 →</Link>
              </span>
            </Reveal>
            <Reveal className="tm-ops-item" delay={160}>
              <h3>Amenities</h3>
              <strong>{BRAND.amenities.slice(0, 4).join(' · ')}</strong>
              <span>바 8석과 4인 테이블로 이루어진 아늑한 공간입니다. 예약 방문을 권장합니다.</span>
            </Reveal>
          </div>
        </div>
      </section>

      {/* Trust block */}
      <section className="tm-section tm-section--line">
        <div className="tm-container tm-trust">
          <Reveal>
            <p className="tm-eyebrow">Our Philosophy</p>
            <blockquote>
              “술이 아니라 대화가 머무는 밤.
              <br />
              카드 한 장이 그 대화의 시작이 됩니다.”
            </blockquote>
            <div className="tm-trust-facts">
              <span className="tm-fact-chip"><strong>Since 2017</strong> 국내 최초 타로상담바</span>
              <span className="tm-fact-chip"><strong>SBS</strong> 미운 우리 새끼 출연</span>
              <span className="tm-fact-chip"><strong>16년+</strong> 경력의 전문 타로 리더</span>
              <span className="tm-fact-chip"><strong>출판·제작</strong> 타로 서적과 타로카드</span>
            </div>
          </Reveal>
        </div>
      </section>

      {/* Content bridge */}
      <section className="tm-section tm-section--line tm-section--deep">
        <div className="tm-container">
          <Reveal>
            <div className="tm-hub-head">
              <div>
                <p className="tm-eyebrow">From the Archive</p>
                <h2 className="tm-h2">타로를 읽는 시간</h2>
              </div>
              <Link className="tm-arrow-link" to="/archive">
                콘텐츠 전체 보기
                <ArrowIcon />
              </Link>
            </div>
          </Reveal>
          <div className="tm-content-grid">
            {CONTENT_TEASERS.map((item, index) => (
              <Reveal key={item.title} className="tm-content-card" delay={index * 80}>
                <span className="tm-tag">{item.tag}</span>
                <h3 className="tm-h3">{item.title}</h3>
                <p className="tm-body-text">{item.description}</p>
                <Link className="tm-arrow-link" to="/archive">
                  읽어보기
                  <ArrowIcon />
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="tm-cta-band tm-section">
        <div className="tm-container">
          <Reveal>
            <h2 className="tm-h2">
              오늘 밤, 카드 한 장과 칵테일 한 잔.
            </h2>
            <div className="tm-hero-actions">
              <Link className="tm-btn tm-btn--solid" to="/reserve">예약하기</Link>
              <Link className="tm-btn tm-btn--ghost" to="/visit">방문 안내</Link>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
